import { Chart as ChartJS } from 'chart.js';

ChartJS.defaults.font.family =
  'Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif';
ChartJS.defaults.font.size = 12;
ChartJS.defaults.color = '#011723';
